import React, { useEffect, useRef, useState } from 'react';

import playIcon from '@/images/Templates/play.svg';
import stopIcon from '@/images/Templates/stop.svg';
import * as styled from './Video.styled';
import { Placeholder } from './Placeholder';

export enum VideoVariants {
  ABOUT = 'About',
  TEMPLATE = 'Templates',
}

interface IVideo {
  variant: VideoVariants;
  src: any;
  bgColor?: string;
  isTemplateSlug?: boolean;
}

export const Video: React.FC<IVideo> = ({
  variant,
  src,
  bgColor,
  isTemplateSlug,
}) => {
  const [barWidth, setBarWidth] = useState(0);
  const videoElement = useRef(null);

  useEffect(() => {
    const handleBarWidth = () => {
      setBarWidth(
        (videoElement?.current?.currentTime / videoElement?.current?.duration) *
          100,
      );
    };

    const interval = setInterval(() => handleBarWidth(), 100);
    return () => clearInterval(interval);
  }, []);

  const videoContainerRef = useRef(null);

  const [videoPaused, setVideoPaused] = useState(true);

  const playVideo = () => {
    videoElement.current.play();
    setVideoPaused(false);
  };
  const pauseVideo = () => {
    videoElement.current.pause();
    setVideoPaused(true);
  };

  switch (variant) {
    case VideoVariants.ABOUT:
      return (
        <styled.AboutVideoBox>
          <styled.AboutProgressBar>
            <styled.CurrentProgress
              style={{
                width: `${barWidth}%`,
              }}
            />
          </styled.AboutProgressBar>
          <styled.AboutVideoElement
            preload="auto"
            autoPlay
            loop
            playsInline
            muted
            src={src}
            ref={videoElement}
          />
        </styled.AboutVideoBox>
      );
    case VideoVariants.TEMPLATE:
      return (
        <styled.TemplatesVideoContainer ref={videoContainerRef}>
          <styled.TemplatesColoredVideo $bgColor={bgColor}>
            <styled.TemplatesProgressBar>
              <styled.CurrentProgress
                style={{
                  width: `${barWidth}%`,
                }}
              />
            </styled.TemplatesProgressBar>
            {!isTemplateSlug && (
              <styled.PlayStopBox>
                {videoPaused ? (
                  <styled.PlayButton
                    src={playIcon}
                    alt="play"
                    onClick={playVideo}
                  />
                ) : (
                  <styled.StopButton
                    src={stopIcon}
                    alt="stop"
                    onClick={pauseVideo}
                  />
                )}
              </styled.PlayStopBox>
            )}
            <styled.TemplatesVideoBox>
              <Placeholder />
              <styled.TemplatesVideoElement
                preload="auto"
                autoPlay={isTemplateSlug}
                loop
                playsInline
                muted
                src={src}
                ref={videoElement}
              />
            </styled.TemplatesVideoBox>
          </styled.TemplatesColoredVideo>
        </styled.TemplatesVideoContainer>
      );
    default:
      return null;
  }
};
